<nav
  class="tw:relative tw:p-2"
  [ngClass]="{
    'tw:border-b tw:border-surface tw:bg-emphasis': isHomePage(),
  }"
  aria-label="Header Navbar">
  <div class="tw:w-full tw:px-3 tw:flex tw:justify-between tw:gap-2 tw:flex-wrap">
    <div class="tw:flex tw:flex-1 tw:gap-1 tw:items-center tw:overflow-hidden">
      <!-- Button Toggler for Smaller Screen -->
      <p-button
        test-id="header-nav-show-side-menu-set"
        [buttonProps]="{ autofocus: false }"
        (click)="showSideMenu.set(true)"
        styleClass="tw:flex tw:lg:hidden"
        icon="pi pi-bars"
        variant="text"
        severity="secondary" />
      <!-- Logo Section -->
      @if (isHomePage()) {
        <div class="tw:flex tw:items-center tw:me-4 tw:gap-2">
          <a
            test-id="header-nav-img"
            routerLink="/home">
            <img
              class="tw:max-h-[2.2rem]"
              [alt]="appConfigService.appConfig().name || 'GenGuardX'"
              [src]="
                themeService.isDark()
                  ? 'assets/images/brand/logo-light.svg'
                  : 'assets/images/brand/logo-dark.svg'
              " />
          </a>
          <span class="tw:text-color tw:text-xl tw:font-semibold">
            {{ appConfigService.appConfig().name }}
          </span>
          <p-button
            severity="secondary"
            test-id="project-switcher"
            (click)="projectList.toggle($event)">
            <i class="pi pi-box tw:text-color tw:font-semibold"></i>
            <span class="tw:text-color tw:font-semibold">
              {{ projectList.selectedProject()?.name || 'All Projects' }}
            </span>
            <i class="pi pi-chevron-down tw:text-sm tw:ms-1"></i>
          </p-button>
        </div>

        <cor-project-list
          #projectList
          [isHomePage]="isHomePage()" />
      } @else {
        @if (breadcrumbItems().length > 0) {
          <p-breadcrumb
            [model]="breadcrumbItems()"
            [home]="{
              icon: 'pi pi-home',
              routerLink: '/home',
            }"
            [style]="{ '--p-breadcrumb-padding': 0 }"
            styleClass="tw:font-medium">
            <ng-template
              #item
              let-item>
              <a
                test-id="header-nav-router-link"
                class="tw:flex tw:items-center tw:gap-2 tw:max-w-xs tw:text-[var(--p-breadcrumb-item-color)]"
                [ngClass]="{
                  'tw:hover:text-[var(--p-breadcrumb-item-hover-color)]': item.routerLink,
                }"
                [routerLink]="item.routerLink">
                @if (item.icon) {
                  <i [class]="item.icon"></i>
                }
                @if (item.label) {
                  <span class="tw:truncate">
                    {{ item.label }}
                  </span>
                }
              </a>
            </ng-template>
          </p-breadcrumb>
        }
      }
    </div>
    <!-- Add margin-top if unread counts are visible -->
    <div
      class="tw:flex tw:flex-row tw:gap-2 tw:items-center"
      [ngClass]="{
        'tw:mt-1': unreadNotificationCount() || jobBoard.totalCount(),
      }">
      <!-- Open Search -->
      <p-button
        [buttonProps]="{ autofocus: false }"
        (click)="isSearchPanelVisible.set(true)"
        severity="secondary"
        class="tw:lg:flex tw:hidden"
        pTooltip="Search and quickly jump to an object
 (Ctrl + K)"
        tooltipPosition="bottom"
        [styleClass]="isHomePage() ? 'tw:bg-(--p-content-background)!' : ''"
        aria-label="Search"
        test-id="search-button">
        <i class="pi pi-search"></i>
        Search
        <span
          class="tw:ms-2 tw:border tw:border-surface tw:rounded tw:bg-emphasis tw:text-muted-color tw:text-xs tw:px-1 tw:py-0.5"
          [ngClass]="{
            'tw:bg-(--p-content-background)!': !isHomePage(),
          }">
          Ctrl+K
        </span>
      </p-button>
      <p-button
        [buttonProps]="{ autofocus: false }"
        (click)="isSearchPanelVisible.set(true)"
        severity="secondary"
        icon="pi pi-search"
        class="tw:lg:hidden tw:flex"
        rounded
        [styleClass]="isHomePage() ? 'tw:bg-(--p-content-background)!' : ''"
        pTooltip="Search and quickly jump to an object
 (Ctrl + K)"
        tooltipPosition="bottom"
        aria-label="Search"
        test-id="search-button" />
      <!-- Job Board -->
      <p-overlaybadge
        [value]="jobBoard.totalCount()"
        [badgeDisabled]="!jobBoard.totalCount()"
        badgeSize="small"
        severity="warn"
        [style]="{ '--p-badge-padding': '0 0.25rem' }">
        <p-button
          [buttonProps]="{ autofocus: false }"
          (click)="jobBoardOverlay.toggle($event)"
          severity="secondary"
          icon="pi pi-clock"
          rounded
          [pTooltip]="
            jobBoard.totalCount() ? 'Background jobs are running' : 'No background jobs running'
          "
          tooltipPosition="bottom"
          test-id="job-summary" />
      </p-overlaybadge>

      <!-- Notifications -->
      <p-overlaybadge
        [value]="unreadNotificationCount()"
        [badgeDisabled]="!unreadNotificationCount()"
        badgeSize="small"
        severity="danger"
        [style]="{ '--p-badge-padding': '0 0.25rem' }">
        <p-button
          [buttonProps]="{ autofocus: false }"
          (click)="onNotificationIconClick()"
          severity="secondary"
          icon="pi pi-bell"
          rounded
          [pTooltip]="
            unreadNotificationCount()
              ? 'You have unread notifications'
              : 'You have no unread notifications'
          "
          tooltipPosition="left"
          test-id="notifications-button" />
      </p-overlaybadge>

      @if (isHomePage()) {
        <!-- User Profile -->
        <cor-profile-popover [avatar]="true" />
      }
    </div>
  </div>
</nav>

<!-- Job Board Popover -->
<p-popover #jobBoardOverlay>
  <div class="tw:flex tw:items-center tw:justify-between tw:p-3 tw:border-b tw:border-surface">
    <div class="tw:text-lg tw:font-semibold">Background Jobs</div>
    <cor-refresh-job-data [displayText]="false" />
  </div>

  <div class="tw:flex tw:flex-col tw:items-center tw:p-3 tw:gap-2">
    @if (jobBoard.totalCount()) {
      @for (jobCard of jobBoard.cards(); track jobCard.title) {
        <div class="tw:flex tw:w-full tw:items-center tw:justify-between tw:font-medium">
          <div class="tw:flex tw:gap-2 tw:items-center tw:text-muted-color">
            <cor-status-icon
              [status]="jobCard.status"
              [showText]="false" />
            <span
              [pTooltip]="jobCard.tooltipData"
              tooltipPosition="bottom">
              {{ jobCard.title }}
            </span>
          </div>
          <span class="tw:text-lg tw:text-muted-color-emphasis">{{ jobCard.count }}</span>
        </div>
      }
    } @else {
      <span class="tw:text-center tw:p-3 tw:text-muted-color">
        No jobs are currently Running, Queued, or Compiling.
      </span>
    }
  </div>

  <div
    class="tw:flex tw:items-center tw:justify-center tw:p-3 tw:gap-1 tw:border-t tw:border-surface">
    <div class="tw:text-muted-color">
      <cor-refresh-job-data [displayIcon]="false" />
    </div>
    <p-button
      test-id="header-nav-more-info"
      (click)="jobBoardOverlay.hide(); jobBoard.isDialogVisible.set(true)"
      [buttonProps]="{ autofocus: false }"
      styleClass="tw:py-0"
      variant="text"
      label="More Info" />
  </div>
</p-popover>

<p-dialog
  [(visible)]="jobBoard.isDialogVisible"
  header="Background Jobs"
  [modal]="true"
  [draggable]="false"
  [blockScroll]="true"
  [resizable]="false"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [focusOnShow]="false"
  appendTo="body"
  [style]="{
    width: '90vw',
    height: '90vh',
  }">
  @if (jobBoard.isDialogVisible()) {
    <cor-job-board />
  }
</p-dialog>

<cor-dialog-box
  [(visible)]="isTimeoutReminderVisible"
  title="Session Timeout">
  <p>
    {{ `Your session is about to expire, you will be logged out in ${(countDown$ | async)}` }}
  </p>

  <ng-template #footer>
    <div class="tw:flex tw:gap-2">
      <p-button
        test-id="header-nav-logout"
        [buttonProps]="{ autofocus: false }"
        [loading]="isTokenRefreshing()"
        [disabled]="isTokenRefreshing()"
        (click)="logoutUser()"
        severity="danger"
        icon="pi pi-sign-out"
        label="Logout" />
      <p-button
        test-id="header-nav-continue-session"
        [buttonProps]="{ autofocus: false }"
        [loading]="isTokenRefreshing()"
        [disabled]="isTokenRefreshing()"
        icon="pi pi-refresh"
        (click)="continueUserSession()"
        label="Continue Session" />
    </div>
  </ng-template>
</cor-dialog-box>

<p-drawer
  [(visible)]="showSideMenu"
  [showCloseIcon]="false"
  styleClass="tw:w-[18rem]"
  position="left">
  <ng-template #headless>
    <cor-sidebar-nav
      (onClose)="showSideMenu.set(false)"
      [showAsOverlay]="true" />
  </ng-template>
</p-drawer>

<cor-global-search [(isSearchPanelVisible)]="isSearchPanelVisible" />
